import _extends from "@babel/runtime/helpers/esm/extends";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import { createElement } from "@wordpress/element";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

/**
 * External dependencies
 */
import { every, isEqual } from 'lodash';
/**
 * WordPress dependencies
 */

import { Component } from '@wordpress/element';
import { createHigherOrderComponent } from '@wordpress/compose';
export default (function (mapNodeToProps) {
  return createHigherOrderComponent(function (WrappedComponent) {
    return /*#__PURE__*/function (_Component) {
      _inherits(_class, _Component);

      var _super = _createSuper(_class);

      function _class() {
        var _this;

        _classCallCheck(this, _class);

        _this = _super.apply(this, arguments);
        _this.nodeRef = _this.props.node;
        _this.state = {
          fallbackStyles: undefined,
          grabStylesCompleted: false
        };
        _this.bindRef = _this.bindRef.bind(_assertThisInitialized(_this));
        return _this;
      }

      _createClass(_class, [{
        key: "bindRef",
        value: function bindRef(node) {
          if (!node) {
            return;
          }

          this.nodeRef = node;
        }
      }, {
        key: "componentDidMount",
        value: function componentDidMount() {
          this.grabFallbackStyles();
        }
      }, {
        key: "componentDidUpdate",
        value: function componentDidUpdate() {
          this.grabFallbackStyles();
        }
      }, {
        key: "grabFallbackStyles",
        value: function grabFallbackStyles() {
          var _this$state = this.state,
              grabStylesCompleted = _this$state.grabStylesCompleted,
              fallbackStyles = _this$state.fallbackStyles;

          if (this.nodeRef && !grabStylesCompleted) {
            var newFallbackStyles = mapNodeToProps(this.nodeRef, this.props);

            if (!isEqual(newFallbackStyles, fallbackStyles)) {
              this.setState({
                fallbackStyles: newFallbackStyles,
                grabStylesCompleted: !!every(newFallbackStyles)
              });
            }
          }
        }
      }, {
        key: "render",
        value: function render() {
          var wrappedComponent = createElement(WrappedComponent, _extends({}, this.props, this.state.fallbackStyles));
          return this.props.node ? wrappedComponent : createElement("div", {
            ref: this.bindRef
          }, " ", wrappedComponent, " ");
        }
      }]);

      return _class;
    }(Component);
  }, 'withFallbackStyles');
});
//# sourceMappingURL=index.js.map